import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { SdObjType } from '../Enums/SdObjType.enum';

import { User } from './User.entity';

export class OutlookAddress<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: sdObjMemberCode */
  sdObjMemberId?: number;
  /** Alias: sdObjType */
  sdObjType?: SdObjType;
  /** Alias: ansprechpCode */
  contactId?: number;
  /** Alias: bCode */
  userId?: number;
  /** Alias: modificationDate */
  modificationDate?: string;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;
  /** Alias: user */
  user?: User<T>;

  __typename?: string;
}

const fields: FieldDefinitions<OutlookAddress> = {
  id: {
    alias: 'code',
  },
  sdObjMemberId: {
    alias: 'sdObjMemberCode',
  },
  sdObjType: {
    alias: 'sdObjType',
  },
  contactId: {
    alias: 'ansprechpCode',
  },
  userId: {
    alias: 'bCode',
  },
  modificationDate: {
    alias: 'modificationDate',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  user: {
    alias: 'user',
    entity: Entities.user,
  },
  __typename: {
    alias: '__typename',
  },
};

export const outlookAddressEntityDefinition: EntitiyDefinition<OutlookAddress> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'OutlookAdresse',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
